export default __webpack_public_path__ + "static/media/j2.fa5ece5a.JPG";